import React, { useState, useEffect } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { asset } from "../services/api";
import "../styles/Favoris.css"

function Favoris() {
  const [favoris, setFavoris] = useState([]);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("favoris")) || [];
    setFavoris(saved);
  }, []);

  const supprimerFavori = (id) => {
    const newFavoris = favoris.filter((f) => f.id !== id);
    setFavoris(newFavoris);
    localStorage.setItem("favoris", JSON.stringify(newFavoris));
  };

  if (favoris.length === 0) {
    return <div className="favoris-vide">Aucun produit dans vos favoris ❤️</div>;
  }

  return (
    <div className="favoris-container">
      <h2>Mes Favoris ❤️</h2>
      <div className="favoris-list">
        {favoris.map((prod) => (
          <div key={prod.id} className="favoris-card">
            <img src={asset(prod.img)} alt={prod.title || prod.titre} />
            <div className="favoris-info">
              <h3>{prod.title || prod.titre}</h3>
              <p>{prod.price} Ar / {prod.unite || "kg"}</p>
              <button
                className="favoris-supprimer"
                onClick={() => supprimerFavori(prod.id)}
              >
                <FaTrashAlt /> Supprimer
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Favoris;
